import './component-product-placeholder.scss';
import { html } from 'lit';
import ComponentBase from './component-base';

class ComponentProductPlaceholder extends ComponentBase {

    static get tagName() { return 'component-product-placeholder' }

    render() {
        return html`
            <div class="card" aria-hidden="true">
                <div class="card-body">
                    <h5 class="card-title placeholder-glow">
                        <span class="placeholder col-6"></span>
                    </h5>
                    <p class="card-text placeholder-glow">
                        <span class="placeholder col-7"></span>
                        <span class="placeholder col-4"></span>
                        <span class="placeholder col-4"></span>
                        <span class="placeholder col-6"></span>
                        <span class="placeholder col-8"></span>
                    </p>
                    <!--a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6"></a-->
                </div>
            </div>
        `;
    }

}
ComponentProductPlaceholder.Register()
export default ComponentProductPlaceholder;